import { render, staticRenderFns } from "./changeFamilyLeader.vue?vue&type=template&id=a406341a&scoped=true"
import script from "./changeFamilyLeader.vue?vue&type=script&lang=js"
export * from "./changeFamilyLeader.vue?vue&type=script&lang=js"
import style0 from "./changeFamilyLeader.vue?vue&type=style&index=0&id=a406341a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a406341a",
  null
  
)

export default component.exports